import { Routes } from '@angular/router';
import { NonAuthGuard } from '@core/guards/non-auth.guard';
import { AuthGuard } from '@core/guards/auth.guard';
import { TokenGuard } from './core/guards/token.guard';

export const routes: Routes = [
  {
    path: 'back',
    canActivateChild: [AuthGuard],
    loadComponent: () =>
      import('./back-office/layout/back-layout/back-layout.component').then(
        m => m.BackLayoutComponent
      ),
    loadChildren: () => import('@back/back.routing').then(m => m.backRoutes),
  },
  { path: 'no-domain', loadComponent: () => import('@front/no-domain/no-domain.component').then(m => m.NoDomainComponent) },
  {
    path: '',
    canActivate: [TokenGuard],
    loadComponent: () =>
      import('@app/layout/main-layout/main-layout.component').then(
        m => m.MainLayoutComponent
      ),
    loadChildren: () => [
      {
        path: '',
        loadChildren: () =>
          import('@front/front.routing').then(m => m.frontRoutes),
      },
      {
        path: 'auth',
        // canActivate: [NonAuthGuard],
        canMatch: [NonAuthGuard],
        loadChildren: () =>
          import('@auth/auth.routing').then(m => m.authRoutes),
      },
      {
        path: 'error',
        loadComponent: () =>
          import('@front/not-found/not-found.component').then(
            m => m.NotFoundComponent
          ),
        data: {
          title: 'Pagina non trovata',
        },
      },
      {
        path: '**',
        redirectTo: 'error',
      },
    ],
  },
];
